import type {
  GetMyTvmediaNewsletterPreferencesQuery,
  GetTvmediaNewsletterCardContentQuery,
  GetTvmediaNewsletterSignupContentQuery,
  GetTvmediaNewsletterTeaserQuery,
} from './generated';

// Keep the rollout guards at the call sites, while checking every operation
// against the CMS schema during code generation.
export {
  GetMyTvmediaNewsletterPreferencesDocument as myNewsletterPreferencesQuery,
  GetTvmediaNewsletterCardContentDocument as newsletterCardContentQuery,
  GetTvmediaNewsletterSignupContentDocument as newsletterSignupContentQuery,
  GetTvmediaNewsletterTeaserDocument as newsletterTeaserQuery,
  GetTvmediaNewsletterTeaserSchemaDocument as newsletterTeaserSchemaQuery,
} from './generated';

export type NewsletterSignupContentQuery = GetTvmediaNewsletterSignupContentQuery;
export type NewsletterCardContentQuery = GetTvmediaNewsletterCardContentQuery;
export type MyNewsletterPreferencesQuery = GetMyTvmediaNewsletterPreferencesQuery;

type Teaser = NonNullable<GetTvmediaNewsletterTeaserQuery['newsletter_overviews'][number]>;
export type NewsletterTeaserContent = Partial<Omit<Teaser, 'teaser_image'>> & {
  teaser_image?: Partial<NonNullable<Teaser['teaser_image']>> & { id: string };
};
